import { isEqual } from "lodash";
import Widget from "./Widget";
import { BACKGROUND_COLORS, BORDER_COLORS } from "./consts";
import { memo } from "react";
import { ChartWidget } from "../../types/widget";
import { BoxPlotProps, LineProps } from "../../types/dashboard";
import {
  getBoxPlotStudentsAnswers,
  getLineChartQuestionnaires,
} from "../../store/effects/reportingEffects";
import { QueryParams } from "../../types/queries";
import { useAppThunkDispatch } from "../../store/hooks";

const BoxPlotWidget: React.FC<BoxPlotProps> = memo((props) => {
  const dispatch = useAppThunkDispatch();

  const widgetBoxPlotCallBack = (params: QueryParams) => {
    console.log("From BoxPlotChart: ", params);
    dispatch(getBoxPlotStudentsAnswers(params));
  };
  const data = {
    datasets: [
      {
        label: props.title,
        data: props.data,
        backgroundColor: BACKGROUND_COLORS,
        borderColor: BORDER_COLORS,
        borderWidth: 1,
      },
    ],
  };

  const boxPlotConfig: ChartWidget = {
    toolbarConfig: {
      periodPicker: true,
      datepicker: true,
      country: true,
      countryConfig: {
        countries: props.countries,
        required: false,
      },
      schools: props.schools,
      queryCB: widgetBoxPlotCallBack,
    },
    chartConfig: {
      type: "box_plot",
      title: props.title,
      data: data,
      endDate: props.endDate,
    },
  };
  return <Widget config={boxPlotConfig} />;
}, isEqual);

export default BoxPlotWidget;

